export const environment = {
  production: false,
  env: 'development',
  API_URL: 'https://api.dev.datastorio.cloud',
  disableTenantApi: false,
};
